import ToolList from '../components/ToolList';
import articles from './article-content';
import { Container, Typography} from '@mui/material';

const ToolsListPage = () => {
    return(
        <Container maxwidth="lg" sx={{ mt:10 }}>
            <Typography variant="h4" gutterBottom>
                Cogo Tools
            </Typography>
            <ToolList tools={articles} />
        </Container>
    )
}

export default ToolsListPage;